import React from "react"

const HowItWorks = () => {
  return <div>how it works</div>
}

export default HowItWorks
